import { render, staticRenderFns } from "./save-documents-maintenance-edit.vue?vue&type=template&id=6c455646&scoped=true&"
import script from "./save-documents-maintenance-edit.vue?vue&type=script&lang=js&"
export * from "./save-documents-maintenance-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c455646",
  null
  
)

export default component.exports